// extracted by mini-css-extract-plugin
export default {"title":"SectionHeader_title__l+iKE","description":"SectionHeader_description__ugVNV"};